import { useState } from 'react';
import { useLocation } from '../context/LocationContext';

// Top-left delivery strip. Click to change the pincode — prices across the site
// re-fetch for the new state/district.
export default function AddressStrip() {
  const { location, label, hasLocation, setPincode, serviceable } = useLocation();
  const [open, setOpen] = useState(false);
  const [pin, setPin] = useState('');
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);

  const save = async () => {
    setErr('');
    setBusy(true);
    try {
      const { serviceable: ok, reason } = await setPincode(pin);
      if (!ok) { setErr(reason || "We don't deliver to this area yet."); return; }
      setOpen(false);
      setPin('');
    } catch (e) { setErr(e.message); } finally { setBusy(false); }
  };

  return (
    <>
      <button className="addr-strip" onClick={() => { setOpen(true); setPin(location?.pincode || ''); }}>
        <i className="fas fa-location-dot" />
        <span className="addr-text">
          {hasLocation ? (
            <>
              <small>Deliver to</small>
              <strong>{label || location.pincode} {location?.pincode ? `– ${location.pincode}` : ''}</strong>
            </>
          ) : (
            <>
              <small>Delivery location</small>
              <strong>Select your pincode</strong>
            </>
          )}
        </span>
        <i className="fas fa-angle-down caret" />
      </button>

      {!serviceable && hasLocation ? (
        <div className="svc-banner">
          <i className="fas fa-triangle-exclamation" /> We don't deliver to {label} yet — you can still browse.
        </div>
      ) : null}

      {open ? (
        <div className="overlay" onClick={() => setOpen(false)}>
          <div className="modal loc-modal" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={() => setOpen(false)} aria-label="Close">
              <i className="fas fa-xmark" />
            </button>
            <h3><i className="fas fa-location-dot" /> Change delivery location</h3>
            <p className="muted" style={{ marginBottom: 16 }}>
              Prices and delivery are based on your pincode.
            </p>
            <div className="field">
              <label>Pincode</label>
              <input
                value={pin}
                onChange={(e) => setPin(e.target.value.replace(/\D/g, '').slice(0, 6))}
                placeholder="6-digit pincode"
                inputMode="numeric"
                autoFocus
                onKeyDown={(e) => e.key === 'Enter' && pin.length === 6 && save()}
              />
            </div>
            {err ? <p className="form-msg err">{err}</p> : null}
            <button
              className="consult-btn"
              style={{ width: '100%', justifyContent: 'center' }}
              disabled={pin.length !== 6 || busy}
              onClick={save}
            >
              {busy ? 'Checking…' : 'Apply'}
            </button>
          </div>
        </div>
      ) : null}
    </>
  );
}
